var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.model)?_c('w-alert',[_vm._t("title",function(){return [_vm._v(_vm._s(_vm.title))]})],2):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }